import { Directive, HostBinding, HostListener, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Directive({
  selector: 'input[appConnoteSearch]'
})
export class ConnotePickerSearchDirective implements OnDestroy {
  private valueSource = new Subject<string>();

  /**
   * Connote search term.
   */
  public value$ = this.valueSource.pipe(distinctUntilChanged());

  @HostBinding('value')
  public value = '';

  @HostBinding('attr.list')
  public list: string = 'connote-datalist';

  public ngOnDestroy() {
    this.valueSource.complete();
  }

  /**
   * Input connote control number to search.
   * @param term Search term.
   */
  @HostListener('input', ['$event.target.value'])
  public onSearch(term: string) {
    this.valueSource.next(term);
  }
}
